<ul nz-menu class="generic-dropdown-menu ant-dropdown-menu">
  @for (item of items; track item; let last = $last) {
    <li
      nz-menu-item
      class="ant-dropdown-menu-item"
      [attr.data-cy]="'dropdown-menu-item-' + item.key"
      (click)="onItemClick(item)"
      [class.danger-item]="item.color === 'danger'"
      [class.not-allowed]="item.disabled"
      [nzTooltipTitle]="item.disabledTooltip ? itemTooltip : null"
      [nzTooltipArrowPointAtCenter]="true"
      nzTooltipOverlayClassName="lean"
      nz-tooltip
      autoCloseOnScroll
    >
      <ng-template #itemTooltip>
        <liberro-tooltip-content>
            <div tooltipContent>
                <span>{{ item.disabledTooltip }}</span>
            </div>
        </liberro-tooltip-content>
      </ng-template>
      <svg-icon [src]="'/assets/icons/' + item.icon"></svg-icon>
      <span>{{ item.label }}</span>
    </li>

    @if (!last) {
      <li nz-menu-divider></li>
    }
  }
</ul>
